// A 4-state checkbox. Unfortunately a non-standard form element, so
// doesn't work with the keyboard etc.
import {Icon as NewIcon} from '@wandb/components';
// @todo: Migrate to 'Icon' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {LegacyWBIcon} from '@wandb/weave/common/components/elements/LegacyWBIcon';
import React, {memo} from 'react';
// eslint-disable-next-line wandb/no-deprecated-imports
import {Icon} from 'semantic-ui-react';

export type MultiStateCheckboxCheckedState =
  | 'checked'
  | 'unchecked'
  | 'partial'
  | 'unknown';

interface MultiStateCheckboxProps {
  ariaLabel?: string;
  className?: string;
  checked: MultiStateCheckboxCheckedState;
  style?: any;
  dropdown?: boolean;
  theme?: string;
  onClick?(): void;
  onMouseEnter?(): void;
  onMouseLeave?(): void;
}

const MultiStateCheckboxComp: React.FC<MultiStateCheckboxProps> = ({
  className: propsClassName,
  checked,
  style,
  dropdown,
  theme,
  onClick,
  onMouseEnter,
  onMouseLeave,
  ariaLabel,
  ...other
}) => {
  let className = `multi-state-checkbox ${dropdown ? 'with-dropdown' : ''}${
    propsClassName ? ' ' + propsClassName : ''
  }`;

  let checkIcon =
    checked === 'checked' ? (
      <LegacyWBIcon name="check" aria-label={ariaLabel} />
    ) : checked === 'unchecked' ? (
      ' ' // <Icon style={{color: 'white'}} name="flag" />
    ) : checked === 'partial' ? (
      <Icon
        style={{backgroundColor: 'white'}}
        name="minus"
        aria-label={ariaLabel}
      />
    ) : (
      ' ' // <Icon style={{backgroundColor: 'white'}} name="minus" />
    );

  if (theme === 'visibility') {
    className = `visibility-indicator visible-${checked} cursor-pointer`;
    checkIcon =
      checked === 'checked' ? (
        <NewIcon icon="visibility-checked" aria-label={ariaLabel} />
      ) : checked === 'partial' ? (
        <NewIcon icon="visibility-indeterminate" aria-label={ariaLabel} />
      ) : (
        <NewIcon icon="visibility-unchecked" aria-label={ariaLabel} />
      );
  }

  return (
    <div
      {...other}
      className={className}
      style={style}
      onClick={(e: React.SyntheticEvent) => {
        if (onClick) {
          e.stopPropagation();
          onClick();
        }
      }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}>
      {checkIcon}
      {dropdown && <Icon style={{marginRight: 0}} name="dropdown" />}
    </div>
  );
};

export const MultiStateCheckbox = memo(MultiStateCheckboxComp);
